// extracted by mini-css-extract-plugin
module.exports = {"head":"commonLayout_head__3Nqqz","primary":"commonLayout_primary__3EPLE","secondary":"commonLayout_secondary__1E2Dy","body":"commonLayout_body__16wMg"};